




























































































































import Vue, { PropType } from "vue";
import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import NumberText from "@/components/Atoms/Typography/Number/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { BME_PART } from "@/api/types";
import { KEYCODE } from "@/constants/event";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    SpeechBubble,
    Heading,
    NumberText,
    Suffix,
    Body,
    Button,
    ButtonConfig
  },
  props: {
    selectedEvent: {
      type: Object as PropType<Props["selectedEvent"]>,
      required: true
    },
    selectedStudent: {
      type: Object as PropType<Props["selectedStudent"]>,
      required: true
    },
    speechBubble: {
      type: Object as PropType<Props["speechBubble"]>,
      required: true
    }
  },
  computed: {
    courseName() {
      switch (this.selectedStudent.course) {
        case "HUMANITIES":
          return "文";
        case "SCIENCE":
          return "理";
        case "UNSPECIFIED":
          return "未";
        default:
          return "";
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyup);
  },
  methods: {
    getBMELabel(bme) {
      switch (bme) {
        case BME_PART.BEGINNING:
          return "上旬";
        case BME_PART.MIDDLE:
          return "中旬";
        case BME_PART.END:
          return "下旬";
      }
      return "";
    },
    handleKeyup(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.$emit("keyupEsc");
    },
    handleDetailClick() {
      const referenceUrl = this.selectedEvent.reference_url;
      if (referenceUrl) window.open(referenceUrl, "_blank", "noopener");
    }
  }
});
